/* eslint-disable prefer-template */
/* eslint-disable default-param-last */
import { actionType } from 'Config/actionTypes';

const INITIAL_STATE = {
  data: 0,
  isLoading: false,
  responseTime: 0,
  isError: false,
  msgError: '',
};

export const headcountTurnoverEducationReducer = (
  state = INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case actionType.HEADCOUNT_TURNOVER_EDUCATION + '_LOADING':
      return {
        ...state,
        isLoading: true,
      };
    case actionType.HEADCOUNT_TURNOVER_EDUCATION + '_RESULT':
      return {
        ...state,
        data: action.result.data,
        responseTime: action.result.responseTime,
        isLoading: false,
        isError: false,
      };
    case actionType.HEADCOUNT_TURNOVER_EDUCATION + '_FAILED':
      return {
        ...state,
        isError: true,
        msgError: action.err,
        isLoading: false,
      };
    case actionType.HEADCOUNT_TURNOVER_EDUCATION + '_ERROR':
      return {
        ...state,
        isLoading: false,
        isError: true,
        msgError: action.err,
        status: action.status
      }
    default:
      return state;
  }
};
